export const getLanguageDisplayName = (code, locale = 'en') => {
  try {
    if (typeof Intl.DisplayNames === 'function') {
      return new Intl.DisplayNames([locale], { type: 'language' }).of(code) || code.toUpperCase();
    }
  } catch {
    // Fall back to the normalized language code when the browser cannot format it.
  }
  return code.toUpperCase();
};
